
import { Component, Vue } from 'vue-property-decorator'
import GuestCookie from '@/components/guest-cookie'
import Squircle from '@/components/V3/Squircle.vue'

@Component({
  components: {
    Squircle
  }
})
export default class MainButton extends Vue {
  get style (): string {
    let cssText = `background-color: ${this.widgetColor}`

    if (this.widgetLogo) {
      cssText += `; background-image: url(${this.widgetLogo})`
    }

    return cssText
  }

  get widgetColor (): string {
    return this.$store.getters.widgetColor
  }

  get widgetLogo (): string | null {
    return this.$store.getters.widgetLogo
  }

  getClass (): string {
    let clss = 'chawgt-main-closed'
    if (this.$store.getters.state === 'shown') {
      clss = 'chawgt-main-open'
    } else if (this.$store.getters.state === 'webchat') {
      clss = 'chawgt-main-back'
    }
    return clss
  }

  toggle (): void {
    this.$store.commit('setNeedCta', false)
    if (this.$store.getters.state === 'shown') {
      GuestCookie.storeGuest('close', this.$store.getters.account, 'on')
      this.$store.commit('setState', 'hidden')
    } else if (this.$store.getters.state === 'back') {
      this.$store.commit('setState', 'shown')
    } else {
      this.$store.commit('setState', 'shown')
      this.$store.commit('webchat/updateStep', 'button')
    }
  }

  created (): void {
    const autoOpen = this.$store.getters.autoOpen
    const hasBeenClosed = GuestCookie.readGuest(
      'close', this.$store.getters.account)
    const hasWebchatSession = (this.$store.getters.channels || [])
      .some((channel: any) => {
        return channel.name === 'web_chat' &&
          GuestCookie.readGuest(
            'guest',
            channel.settings.bot_identifier,
            true
          )
      })

    if (hasBeenClosed === null) {
      if (hasWebchatSession) {
        this.$store.commit('setState', 'shown')
      } else if (autoOpen !== null && autoOpen > 0) {
        window.setTimeout(() => {
          if (this.$store.getters.state === 'hidden') {
            this.toggle()
          }
        }, autoOpen * 1000)
      }
    }
  }
}
